import { useRecoilCallback } from 'recoil';
import WxContentsDispatcher from './WxContentsDispatcher';
import { useExecutePreMount } from '../../../hooks/useExecutePreMount';
import { modelLevelWithID } from '../../../store/ModelLevelState';
import {
  weatherVisibleWithID,
  WX_ID_GFS,
  WX_ID_GSM,
  WX_ID_LFM,
  WX_ID_MSM,
} from '../../../store/WeatherContentsState';
import ModelLFM from '../../crosssection/contents/ModelLFM';
import ModelMSM from '../../crosssection/contents/ModelMSM';
import ModelGFS from '../../crosssection/contents/ModelGFS';
import ModelGSM from '../../crosssection/contents/ModelGSM';
import { csChangeSettingWithId } from '../../../store/CsSettingState';
import { useLayoutState } from '../../../store/LayoutState';
import useEffectSkipFirst from '../../../hooks/useEffectSkipFirst';
import {
  useDisplayOperationRecoilState,
} from '../../../hooks/useDisplayOperation';

const ModelDispatcher = (props) => {
  const { contentsID, contents } = props;
  let CS_NAME;
  let resolveCsTargetName;
  if (contentsID === WX_ID_LFM) {
    CS_NAME = ModelLFM.CS_NAME;
    resolveCsTargetName = ModelLFM.resolveCsTargetName;
  } else if (contentsID === WX_ID_MSM) {
    CS_NAME = ModelMSM.CS_NAME;
    resolveCsTargetName = ModelMSM.resolveCsTargetName;
  } else if (contentsID === WX_ID_GFS) {
    CS_NAME = ModelGFS.CS_NAME;
    resolveCsTargetName = ModelGFS.resolveCsTargetName;
  } else if (contentsID === WX_ID_GSM) {
    CS_NAME = ModelGSM.CS_NAME;
    resolveCsTargetName = ModelGSM.resolveCsTargetName;
  }

  const [, setCsState] = useDisplayOperationRecoilState({
    path: CS_NAME,
    key: 'value',
    function: 'setContentsSettings'
  }, csChangeSettingWithId(CS_NAME));

  const { isMapOnly } = useLayoutState();

  const dispatcher = useRecoilCallback(
    ({ set, snapshot }) =>
      async (action) => {
        const release = snapshot.retain();

        try {
          if (action.type === 'SET_MODEL_LEVEL') {
            set(modelLevelWithID(contentsID), action.payload);
          } else if (action.type === 'SET_MODEL_CONTENTS_VISIBLE') {
            // MapのModel要素の変更を断面図のステートに伝搬させる
            const { targetName, visible } = action.payload;

            const csTargetName = resolveCsTargetName(targetName);

            const csState = await snapshot.getLoadable(csChangeSettingWithId(CS_NAME)).contents;

            let newCsState = { ...csState };
            if (csState.hasOwnProperty(csTargetName)) {
              newCsState[csTargetName] = visible;
              setCsState(newCsState);
            }
            let csAllOff = true;

            if (!isMapOnly && 0 < Object.keys(newCsState).filter((k) => newCsState[k]).length) {
              csAllOff = false;
            }
            const newState = contents.getContentsVisibleState();
            if (
              Object.keys(newState)
                .filter((key) => contents.getContentsKeys().includes(key))
                .filter((key) => newState[key]).length === 0 &&
              csAllOff
            ) {
              set(weatherVisibleWithID(contentsID), false);
            }
          }
        } finally {
          release();
        }
      },
    [isMapOnly]
  );

  useExecutePreMount(() => {
    contents.setModelDispatcher(dispatcher);
  });

  useEffectSkipFirst(() => {
    contents.setModelDispatcher(dispatcher);
  }, [dispatcher]);

  return <WxContentsDispatcher {...props} />;
};

export default ModelDispatcher;
